export { H1, H2, H3, H4, H5, H6, Strong, Em, P } from './Typography'
